import { getAllowedMenu } from "@erp/shared/api/generated/wrappers/user";
import { setCookie } from "@erp/shared/utils/cookie/setCookie";
import { queryClient } from "@erp/shared/plugins/vue-query";
import { compact } from "es-toolkit";
import { defineStore } from "pinia";
import { ref } from "vue";
import { isAuthExpiredError } from "@erp/shared/api/_type/AuthErrorType";
import { queries } from "../queries";
/**
 * @description 라우터 사용을 위해, 훅이 없는 store
 */
export const useUserInitStore = defineStore("login", () => {
    const user = ref(null);
    const allowedMenus = ref([]);
    const userGroupIds = ref([]);
    const initFailed = ref(false);
    const setUser = (u) => {
        user.value = u;
        if (!u) {
            userGroupIds.value = [];
            return;
        }
        const userGroups = u.groups.map((group) => {
            return group.id;
        }) || [];
        userGroupIds.value = compact(userGroups);
        userGroupIds.value.length > 0 &&
            setCookie("permission_group_ids", userGroupIds.value.join(","));
    };
    const setAllowedMenus = (menus) => {
        allowedMenus.value = menus;
        setCookie("allowed_urls", menus.join(","));
    };
    const initialUserStore = async (isLoginPage) => {
        try {
            initFailed.value = false;
            if (!isLoginPage) {
                // 이미 캐시에 있으면 네트워크를 건너뛰고 재사용
                let initialUser = null;
                const cachedUser = queryClient.getQueryData(queries.user.loginUser().queryKey);
                if (cachedUser) {
                    initialUser = cachedUser;
                }
                else {
                    initialUser =
                        await queryClient.fetchQuery({
                            ...queries.user.loginUser(),
                            staleTime: 1000 * 60 * 60 * 24,
                            gcTime: 1000 * 60 * 60 * 24,
                        });
                    queryClient.setQueryData(queries.user.loginUser().queryKey, initialUser ?? null);
                }
                setUser(initialUser ?? null);
                let allowedMenus = null;
                const cachedAllowedMenus = queryClient.getQueryData(queries.user.allowedMenu().queryKey);
                if (cachedAllowedMenus) {
                    const raw = cachedAllowedMenus;
                    allowedMenus =
                        typeof raw === "string" && raw.length > 0 ? raw.split(",") : [];
                }
                else {
                    const raw = await getAllowedMenu();
                    allowedMenus =
                        typeof raw === "string" && raw.length > 0 ? raw.split(",") : [];
                    queryClient.setQueryData(queries.user.allowedMenu().queryKey, raw);
                }
                setAllowedMenus(allowedMenus || []);
            }
            else {
                // 로그인 페이지에서는 이전 사용자 캐시가 남아 있지 않도록 정리
                queryClient.removeQueries({
                    queryKey: queries.user.loginUser().queryKey,
                    exact: true,
                });
                queryClient.removeQueries({
                    queryKey: queries.user.allowedMenu().queryKey,
                    exact: true,
                });
            }
        }
        catch (error) {
            const isAuthError = isAuthExpiredError(error);
            if (isAuthError) {
                return;
            }
            initFailed.value = true;
            console.error("사용자 정보 초기화 실패:", error);
        }
    };
    // 필요한 경우 Promise 노출 등 추가 가능
    return {
        user,
        allowedMenus,
        userGroupIds,
        initFailed,
        setUser,
        setAllowedMenus,
        initialUserStore,
    };
});
